export default __webpack_public_path__ + "static/media/flag-br.3d4f4385.svg";